/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { DefaultAngularLand } from 'src/app/common/fancy-firebase/util/default-angular-land.service';
import {
	FancyListIndexDumpFactory,
	FirebaseListFactory,
	PriorityListFactory,
	ProjectListFactory,
	VarianceListFactory,
} from 'src/app/common/fancy-firebase/services/factories';
import { FancyIdJoin } from 'src/app/common/fancy-firebase/base/FancyIdJoin';
import { FancyFragmenter } from 'src/app/common/fancy-firebase/base/FancyFragmenter';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import {
	fancyFirebaseGetters,
	fancyFirebaseReferencer,
	ProjectCatalogType,
} from '@touchplan/fancy-referencer';
import { OrganizationList } from 'src/app/common/fancy-firebase/lists/OrganizationList';
import { OrganizationsApi } from 'src/app/app-data/state/OrganizationsApi';

import firebase from 'firebase/compat/app';

@Injectable({
	providedIn: 'root',
})
export class FancyFirebaseOrganizationsApiBuilder {
	constructor(
		private db: AngularFireDatabase,
		private defaultAngularLand: DefaultAngularLand,
		private firebaseListFactory: FirebaseListFactory,
		private fancyListIndexDumpFactory: FancyListIndexDumpFactory
	) {}

	public getOrganizationsApi(userId: string) {
		const orgList = this.makeOrganizationList(userId);
		return new OrganizationsApi(orgList);
	}

	private makeOrganizationList(userId: string) {
		const angularland = this.defaultAngularLand;

		const orgPath = fancyFirebaseGetters.getOrganizationsPath();
		const orgRef = fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(orgPath);
		const orgFragment = new FancyFragmenter(angularland, orgRef);
		const orgList = this.firebaseListFactory.create(OrganizationList, orgFragment.emitter$);
		orgFragment.start();

		orgList.listRef = this.db.list(orgRef);

		const orgFragmentJoiner = new FancyIdJoin('$id', orgList, orgFragment);

		const indicesUsersPath = fancyFirebaseGetters.getIndicesUsersOrganizationPath(userId);
		const listIndexer = this.fancyListIndexDumpFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(indicesUsersPath),
			orgFragmentJoiner
		);

		orgList.addDestroyer(
			() => listIndexer.destroy(),
			() => orgFragmentJoiner.destroy(),
			() => orgFragment.destroy()
		);
		return orgList;
	}
}
